import { render, staticRenderFns } from "./honorAdd.vue?vue&type=template&id=2a49b052&scoped=true"
import script from "./honorAdd.vue?vue&type=script&lang=js"
export * from "./honorAdd.vue?vue&type=script&lang=js"
import style0 from "./honorAdd.vue?vue&type=style&index=0&id=2a49b052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49b052",
  null
  
)

export default component.exports